import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { useDataAttributes } from '@lumapps/data-attributes';
import { mdiClose } from '@lumapps/lumx/icons';
import { Emphasis, IconButton } from '@lumapps/lumx/react';
import { GLOBAL, useTranslate } from '@lumapps/translations';
import { useSlateStatic, useSelected } from '@lumapps/wrex/slate';
import { useInlineVoid } from '@lumapps/wrex/slate/utils/useInlineVoid';
import { ElementRender, WrexEditor } from '@lumapps/wrex/types';

import type { IframeEditor, IframeElement } from '../../../types';
import { CLASSNAME, Iframe } from '../../blocks/Iframe';

import './index.scss';

export const EditableIframe: ElementRender<IframeElement, HTMLDivElement> = ({
    element = {} as IframeElement,
    children,
    ...forwardedProps
}) => {
    const editorStatic = useSlateStatic() as WrexEditor<IframeEditor>;
    const selected = useSelected();
    const { onFocus, onDelete } = useInlineVoid(editorStatic, element);
    const { block, element: classElement } = useClassnames(CLASSNAME);
    const { get } = useDataAttributes(CLASSNAME);
    const { translateKey } = useTranslate();

    return (
        <Iframe
            className={block({
                editable: true,
                selected,
            })}
            element={element}
            onFocus={onFocus}
            tabIndex={0}
            {...forwardedProps}
        >
            <div className={classElement('actions')}>
                <IconButton
                    icon={mdiClose}
                    emphasis={Emphasis.low}
                    hasBackground
                    onClick={onDelete}
                    label={translateKey(GLOBAL.DELETE)}
                    {...get({ element: 'button', action: 'delete-iframe' })}
                />
            </div>
            {children}
        </Iframe>
    );
};

EditableIframe.displayName = 'iframe';
